var _rect, _path, _ellipse, _path2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 15.9054,
    rx: 3,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8524 14.3918C11.8524 17.6874 10.1097 16.9233 7.95996 16.9233C5.81025 16.9233 4.06757 17.6874 4.06757 14.3918C4.06757 11.0963 5.81025 8.42468 7.95996 8.42468C10.1097 8.42468 11.8524 11.0963 11.8524 14.3918Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.16481,
    cy: 5.16987,
    rx: 2.45835,
    ry: 2.16987,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.3918C20 17.6874 18.2573 16.9233 16.1076 16.9233C13.9579 16.9233 12.2152 17.6874 12.2152 14.3918C12.2152 11.0963 13.9579 8.42468 16.1076 8.42468C18.2573 8.42468 20 11.0963 20 14.3918Z",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3125,
    cy: 5.16987,
    rx: 2.45835,
    ry: 2.16987,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrm);
export default __webpack_public_path__ + "static/media/mrm.54a45b9436ec0c8891e61d433d3c0e90.svg";
export { ForwardRef as ReactComponent };